let sendOnChange = (element) => {
    if ("createEvent" in document) {
        let evt = document.createEvent("HTMLEvents");
        evt.initEvent("input", false, true);
        element.dispatchEvent(evt);
    } else {
        element.fireEvent("oninput");
    }
};

export default  sendOnChange;
